import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { requestGet } from '../../api/request';
import { parseDateTime } from '../Partials/Helper';
import * as actions from '../../redux/actions';
import { HOME_EVENT } from '../../api/url';

const EvTelegrams = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const [event, setEvent] = useState([]);
  const [selectedSearchByDate, setSelectedSearchByDate] = useState(searchParams.get('date') || null);

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(HOME_EVENT, {
      'event_type': 'telegrams',
      'searchByDate': selectedSearchByDate,
      'lang_id': currentLanguage.id,
    });

    if (response.success) {
      setEvent(response.data);
      setLoader(false);
    }
  };

  useEffect(() => {
    // Handle date url params;
    if (searchParams.get('date')) {
      setSelectedSearchByDate(searchParams.get('date'));
    } else {
      setSelectedSearchByDate(null);
      setSearchParams('');
    }
  }, [searchParams]);

  useEffect(() => {
    getData();
  }, [selectedSearchByDate, currentLanguage]);

  useEffect(() => {
    if (event.length > 0) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  const handleKeyPress = (e, value) => {
    if (e.key === 'Enter') {
      setSelectedSearchByDate(value);
    }
  };

  const showDatas = () => (
    event.map((data) => (
      <div className="col-lg-6" key={data.id}>
        <div className="main-tab__item">
          <a
            onClick={(e) => {
              e.preventDefault();
              navigate(`/event/telegrams/${data.id}`);
            }}
            href={`/event/telegrams/${data.id}`}
            className="main-tab__title"
          >
            {data.title || data.name}
          </a>
          <div className="saidbar-item__box">
            <div className="saidbar-item__date">
              <span>{parseDateTime(data.publish_date)}</span>
              {data.city_relation.length > 0
                ? data.city_relation.map((cityValue) => (
                  <span
                    key={cityValue.id}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/search_by_region/?q=${cityValue.city.name}`);
                    }}
                    style={{
                      cursor: 'pointer',
                      marginLeft: '4px',
                      marginBottom: '0px',
                      fontSize: '14px',
                    }}
                    className="main-tab__title"
                    onKeyDown={handleKeyPress}
                    role="button"
                    tabIndex="0"
                    aria-label="event"
                  >
                    {cityValue.city.name}
                  </span>
                ))
                : null}
              {data.country_relation.length > 0
                ? data.country_relation.map((countryValue) => (
                  <span key={countryValue.id}>
                    {' '}
                    {countryValue.country.name}
                  </span>
                ))
                : null}
            </div>
            <div className="saidbar-item__right d-lg-none">
              <div className="saidbar-item__info">
                <div className="saidbar-item__img">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="12"
                    viewBox="0 0 15 12"
                  >
                    <path
                      className="st0"
                      d="M4.1,5.3c0.6,0,1.1-0.5,1.1-1.1S4.7,3,4.1,3S3,3.5,3,4.1S3.5,5.3,4.1,5.3z"
                      fill="#5F5F5F"
                    />
                    <path
                      className="st0"
                      d="M6.4,7.5L5.2,6L3,9h9L8.6,4.5L6.4,7.5z"
                      fill="#5F5F5F"
                    />
                    <path
                      className="st0"
                      d="M13.5,0h-12C0.7,0,0,0.7,0,1.5v9C0,11.3,0.7,12,1.5,12h12c0.8,0,1.5-0.7,1.5-1.5v-9C15,0.7,14.3,0,13.5,0zM1.5,10.5v-9h12l0,9H1.5L1.5,10.5z"
                      fill="#5F5F5F"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  );

  return (
    <div className="tab-content" id="myTabContent">
      {loader === true ? (
        <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only" />
          </div>
        </div>
      ) : null}
      {event.length > 0 ? (
        <div
          className="tab-pane fade show active"
          id="telegrams"
          role="tabpanel"
          aria-labelledby="telegrams-tab"
        >
          <div className="row">{showDatas()}</div>
          <div className="main-tab__button">
            <a
              onClick={(e) => {
                e.preventDefault();
                navigate('/event/telegrams');
              }}
              href="/event/telegrams"
              className="button button-update"
            >
              {dictionary.more}
            </a>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default EvTelegrams;
